module.exports = __webpack_public_path__ + "static/media/background-event-title-902-ja.5b453e9e.png";